import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaisesListarService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Lista de paises
   */
  getCountryList(): Observable<object> {
    const headerConfig: NgxHttpClientExtraOptions = {
      headers: new HttpHeaders()
      // .append( 'Content-Type', 'application/x-www-form-urlencoded' )
    };
    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.paisesListar.name,
      headerConfig
    ).pipe(
      // map( ( e: any[] ) => e.map( r => new CountryListModel( r ) ) )
    );
  }

}
